
import { createContext } from 'react';
/*this context allows any component to reference one backend object
  https://reactjs.org/docs/context.html*/

export const BackendContext = createContext();